import api from '@/services/Api';

class Awards {
  /**
   * @returns {AxiosPromise<any>}
   */
  static all(params = []) {
    return api.get('/awards/awards', {
      params,
    });
  }

  static get(id) {
    return api.get(`/awards/awards/${id}`);
  }

  static closeReviewPhase(id) {
    return api.post(`/awards/awards/${id}/close-review-phase`);
  }

  static closeSelectionPhase(id) {
    return api.post(`/awards/awards/${id}/close-selection-phase`);
  }

  static closeAward(id) {
    return api.post(`/awards/awards/${id}/close`);
  }

  static uploadFile(id, payload) {
    return api.post(`/awards/awards/${id}/upload`, payload);
  }
}

export default Awards;
